import { ButtonBase, styled } from '@mui/material';

export const DpBaseButton = styled(ButtonBase)<{
	variant?: 'primary' | 'secondary';
}>(({ theme, variant = 'primary' }) => ({
	height: '44px',
	backgroundColor: variant === 'primary' ? theme.palette.primary.main : '#F1F1F1',
	color: variant === 'primary' ? theme.palette.common.white : '#2C2C2C',
	fontSize: 'var(--font-size-body)',
	fontWeight: 'bold',
	borderRadius: '60px',
	padding: '0px 10px',
	'&:hover': { backgroundColor: '#0064C7' },
}));
